import { QueryClient } from "@tanstack/react-query";
import { redirect } from "react-router";
import { USERS_QUERIES } from "~/shared/api/users/users.queries";

export async function onboardedGuardLoader(queryClient: QueryClient) {
  const user = await queryClient.ensureQueryData(USERS_QUERIES.profile());

  if (!user?.codeOfConduct) {
    return redirect(`/onboarding`);
  }

  return null;
}
